import { cx } from '@linaria/core';
import { CircularButton, ChevronIcon, Tooltip, ExternalLinkIcon, OpenIcon, DownloadIcon } from '@ui/kit';
import { buttonWrapper, chevron } from './atom.button.style.js';
import { jsx } from 'react/jsx-runtime';

function CardButton(props) {
  return /*#__PURE__*/jsx("div", {
    className: cx(buttonWrapper, props.className),
    children: /*#__PURE__*/jsx(Content, {
      ...props
    })
  });
}
function Content(props) {
  switch (props.icon) {
    case "download":
      return /*#__PURE__*/jsx(Tooltip, {
        placement: "right",
        body: "Download",
        ariaType: "label",
        children: ref => /*#__PURE__*/jsx(CircularButton, {
          as: "div",
          ref: ref,
          icon: /*#__PURE__*/jsx(DownloadIcon, {}),
          size: "large",
          theme: props.theme
        })
      });
    case "lightbox":
      return /*#__PURE__*/jsx(Tooltip, {
        placement: "right",
        body: "Box ovenp\xE5",
        ariaType: "label",
        children: ref => /*#__PURE__*/jsx(CircularButton, {
          as: "div",
          ref: ref,
          icon: /*#__PURE__*/jsx(OpenIcon, {}),
          size: "large",
          theme: props.theme
        })
      });
    case "new-tab":
      return /*#__PURE__*/jsx(Tooltip, {
        placement: "right",
        body: "Nyt vindue",
        ariaType: "label",
        children: ref => /*#__PURE__*/jsx(CircularButton, {
          as: "div",
          ref: ref,
          icon: /*#__PURE__*/jsx(ExternalLinkIcon, {}),
          size: "large",
          theme: props.theme
        })
      });
    case "same-tab":
      return /*#__PURE__*/jsx(CircularButton, {
        as: "div",
        icon: /*#__PURE__*/jsx(ChevronIcon, {
          className: chevron
        }),
        size: "large",
        theme: props.theme
      });
    default:
      return null;
  }
}

export { CardButton };
//# sourceMappingURL=atom.button.js.map
